import EditableContent from "./EditableContent";
import withProps from "recompose/withProps";
import {
  GIFTWRAP_ADDON_TYPES,
  getAddonsOfType,
  getAddonsNotOfType,
} from "src/common/utils/addons";

const enhance = withProps((props) => {
  const giftwrapAddons = getAddonsOfType(props.addons, GIFTWRAP_ADDON_TYPES);
  const extraAddons = getAddonsNotOfType(props.addons, GIFTWRAP_ADDON_TYPES);
  return {
    giftwrapAddons,
    extraAddons,
  };
});

export default enhance(EditableContent);
